export default __webpack_public_path__ + "static/media/test5.9785954a.jpg";